import { createSelectField } from 'components';
import { createOptions } from 'options';
import { campaingGoals } from './types';

const goalOptions = createOptions(campaingGoals);
export const CampaignGoalsField = createSelectField(goalOptions, { simple: true, isMulti: true });
